import { Button, UIText3, useDeviceType } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/common';
import styles from './styles.css';
import React from 'react';
import cn from 'clsx';

interface ICreditInfoModalFooterProps {
  handleFillApplicationClick: () => void;
  buttonText?: string;
}

export const CreditInfoModalFooter: React.FC<ICreditInfoModalFooterProps> = ({
  handleFillApplicationClick,
  buttonText,
}) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles.container, styles[deviceType])}>
      <Button size="L" onClick={handleFillApplicationClick} fullWidth={deviceType === 'phone'}>
        {buttonText || 'Заполнить заявку на Циане'}
      </Button>
      {/* buttonText есть только у ТБанка, кнопка ведет на их сайт, поэтому не нужно показывать регуляторный текст */}
      {!buttonText && (
        <div className={cn(styles['text-container'], styles[deviceType])}>
          <UIText3 color="text-secondary-default" textAlign={deviceType === 'phone' ? 'center' : 'right'}>
            {`Заявка${NBSP}— единая для всех банков. Не оферта.`}
          </UIText3>
          <UIText3 color="text-secondary-default" textAlign={deviceType === 'phone' ? 'center' : 'right'}>
            {`Перед заполнением попросим авторизоваться.`}
          </UIText3>
        </div>
      )}
    </div>
  );
};
